<div class="sign-in">
  <div class="left">
    <ng-container *ngIf="!pwdResetCodeSent; else updatePassword">
      <div class="container">
        <img src="assets/images/Isolation_Mode.svg" alt="App Icon"
          style="align-items: start; padding-bottom: 30px; width: 98%;">
        <h1 class="title">{{ title }}</h1>
        <p class="sub-title">{{ subTitle }}</p>
        <form [formGroup]="passwordHelpForm" (ngSubmit)="onSubmit(true)" style=" padding-left: 20px;">
          <div class="error-container" *ngIf="authError$ | async">
            {{ authError$ | async }}
          </div>
          <div class="error-container" *ngIf="errorMsg?.trim()">
            {{ errorMsg}}
          </div>
          <div class="form-group">
            <rap-spinner class="loader-view" *ngIf="isLoading" [showSpinner]="false"></rap-spinner>
            <label for="email">Email address</label>
            <div class="input-container">
              <input type="email" class="search-input" [class.submitted]="submitted"
                placeholder="Enter an email address" formControlName="email"
                [ngClass]="{ 'is-invalid': submitted && hasEmailError() }" />
              <div class="auth-icons">
                <i class="bi bi-x-circle-fill" [class.icon-hidden]="!(submitted && hasEmailError())"
                  style="margin-left: 10px;" (click)="clearInput('email')"></i>
                <i class="bi bi-envelope-fill" style="margin-left: 10px;"></i>
                <i class="bi bi-check-circle-fill" [class.icon-hidden]="!(!hasEmailError() && isValidEmail)"
                  style="margin-left: 10px; color: green;"></i>
              </div>
              <!-- <img
                    *ngIf="isEmailEntered"
                    src="../assets/images/x-circle-fill.svg"
                    alt="Clear Icon"
                    class="auth-icons clear"
                    onclick="clearInput('email')"
                  /> -->
            </div>
            <div *ngIf="submitted && f['email'].errors" class="rap-error-text">
              <span *ngIf="f['email'].errors?.['required']">Email is required</span>
              <!-- 'pattern' is the EMAIL_TLD_PATTERN failure (e.g. "foo@g", which
                   Validators.email accepts). Same copy as the 'email' error: to
                   the user it is one problem, and without this the error block
                   would render empty for a no-TLD address. -->
              <span *ngIf="f['email'].errors?.['email'] || f['email'].errors?.['pattern']">Enter valid email</span>
            </div>
            <!-- <div *ngIf="hasEmailError()" class="rap-error-text">
              Please enter a valid email address.
            </div> -->
          </div>

          <!-- <button type="submit" class="btn-signin">

            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span *ngIf="!isLoading">Send Email</span>
          </button> -->
          <!-- Deliberately NOT gated on validity. Gating it created a circular
               dead end: the button was disabled whenever the form was invalid,
               while every error message was gated on `submitted`, which only
               flips inside onSubmit() - which cannot run while the button is
               disabled. So an invalid email produced a grey button and no
               explanation, permanently. Submitting runs the guard in onSubmit()
               and renders the message instead. -->
          <rap-rect-button-loader [isLoading]="isLoading" [disabled]="false" buttonClass="btn btn-dark btn-signin"
            style="padding-top: 10px;" type="submit" (clickEvent)="onSubmit(true)">
            Send Email
          </rap-rect-button-loader>
          <rap-link-divider></rap-link-divider>
          <!-- <button type="button" class="btn-create" (click)="navigateToSignIn()">
            Sign In
          </button> -->
          <rap-rect-button-loader [isLoading]="false" [disabled]="false" buttonClass="btn btn-light btn-create"
            type="button" (clickEvent)="onSubmit(false)">
            Sign in
          </rap-rect-button-loader>
        </form>
        <rap-terms-privacy></rap-terms-privacy>
      </div>
    </ng-container>
  </div>
  <div class="right"></div>
</div>

<ng-template #updatePassword>
  <div class="container">
    <img src="assets/images/Isolation_Mode.svg" alt="App Icon"
      style="align-items: start; padding-bottom: 30px; width: 98%;">
    <h1 class="title">{{ title }}</h1>
    <form [formGroup]="passwordHelpForm" (ngSubmit)="onSubmit()" style=" padding-left: 20px;">
      <div class="error-container" *ngIf="authError$ | async">
        {{ authError$ | async }}
      </div>
      <div class="error-container" *ngIf="error">
        {{ error }}
      </div>
      <div class="error-container" *ngIf="errorMsg?.trim()">
        {{ errorMsg }}
      </div>

      <div class="form-group">
        <rap-spinner class="loader-view" *ngIf="isLoading" [showSpinner]="false"></rap-spinner>
        <label for="code">Temporary Password</label>
        <div class="input-container">
          <input type="text" class="search-input" [class.submitted]="pwdUpdateSubmitted"
            [ngClass]="{'is-invalid': pwdUpdateSubmitted && f['code'].invalid}"
            placeholder="Enter the password emailed to you" formControlName="code" />
          <!-- The shield carried .auth-icons on the <i> itself, with no wrapper.
               That put it outside BOTH `.auth-icons > i` (the #17 slot rule) and
               `.input-container .auth-icons i` (the 13px/black glyph rule), so it
               rendered 16px in a 16px column while every other row used a 24px
               slot. Wrapping it matches the structure used by the email and
               password rows so the shared rules apply. -->
          <div class="auth-icons">
            <i class="bi bi-shield-fill" style="margin-left: 10px;"></i>
          </div>
        </div>
        <div *ngIf="pwdUpdateSubmitted && f['code'].errors" class="rap-error-text">
          <span *ngIf="f['code'].errors?.['required']">Temporary Password is required</span>
          <!-- apiError is set by resetPassword()'s error callback when the server
               rejects the code. Without this span the block rendered empty, so a
               rejected code produced no field-level message at all.
               Deliberately states the ACTION, not the problem: the banner above
               already shows the server's own message ("Code is invalid or
               expired"), and restating it here in different words ("temporary
               password") would read as two separate faults. This points that one
               message at this one field, in the field's own vocabulary.
               Editing the field clears apiError automatically. -->
          <span *ngIf="f['code'].errors?.['apiError']">Re-enter the temporary password from your email.</span>
        </div>
      </div>
      <div class="form-group">
        <label for="password">New password</label>
        <app-password-input [submitted]="pwdUpdateSubmitted" [formControl]="f['password']"
          [showRequirements]="true" [placeHolder]="'Enter a new password'"></app-password-input>
      </div>
      <div class="form-group">
        <label for="confirmPassword">Re-enter new password</label>
        <app-password-input [submitted]="pwdUpdateSubmitted" [formControl]="f['confirmPassword']"
          [placeholder]="'Re-enter the new password'"></app-password-input>
      </div>

      <!-- <button type="submit" class="btn-signin">

        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span *ngIf="!isLoading">Update</span>
      </button> -->
      <!-- Re-gated on validity (reverting 16b0d89's ungating) now that an invalid
           form always states its reason: the policy hint is permanently visible
           beside the password field, and app-password-input reveals the specific
           failed rule on blur or submit. A disabled button is legitimate when the
           reason is on screen; it was only harmful while it was the ONLY signal. -->
      <rap-rect-button-loader [isLoading]="isLoading" [disabled]="!passwordHelpForm.valid" buttonClass="btn btn-dark btn-signin"
        style="padding-top: 10px;" type="submit" (clickEvent)="onSubmit()">
        Update
      </rap-rect-button-loader>
    </form>
    <rap-terms-privacy></rap-terms-privacy>
  </div>
</ng-template>